import { render, staticRenderFns } from "./StepSkills.vue?vue&type=template&id=3929ec5e&scoped=true&"
import script from "./StepSkills.vue?vue&type=script&lang=js&"
export * from "./StepSkills.vue?vue&type=script&lang=js&"
import style0 from "./StepSkills.vue?vue&type=style&index=0&id=3929ec5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3929ec5e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Notification: require('/workspace/components/Notification.vue').default,ValidationSkills: require('/workspace/components/Validation/steps/step-skills/ValidationSkills.vue').default,ValidationSkillsSection: require('/workspace/components/Validation/steps/step-skills/ValidationSkillsSection.vue').default,ValidationContainer: require('/workspace/components/Validation/ValidationContainer.vue').default})
